<!-- MOBILE -->
@if(client.isS || client.isM){
<div>
    <!-- main content -->
    <sticky-free [order]="10"
                 [stickyId]="'store-finder'"
                 class="pos-relative _sticky">
        <div class=" bg-col-w wrap p-t-4 p-b-1 p-b-4">
            <ng-container *ngTemplateOutlet="formTmpl"></ng-container>
        </div>
    </sticky-free>

    <!-- results -->
    <div class="b-b b-col-5 wrap m-t-1 p-b-0">
        <dt class="p2 _tabLink"
            [toggleClass]="'!col-12 _current'"
            [toggleClassBy]="toggleService.getState(['storeFinder', 'map'])"
            (click)="toggleService.open(['storeFinder', 'map'])">{{'Map'|translate}}</dt>
        @if (isResultsView) {
        <dt class="p2 _tabLink"
            [toggleClass]="'!col-12 _current'"
            [toggleClassBy]="toggleService.getState(['storeFinder', 'list'])"
            (click)="toggleService.open(['storeFinder', 'list'])">{{'List'|translate}}</dt>
        }
        @if (!isResultsView) {
        <dt class="p2 _tabLink"
            [toggleClass]="'!col-12 _current'"
            [toggleClassBy]="toggleService.getState(['storeFinder', 'popular'])"
            (click)="toggleService.open(['storeFinder', 'popular'])">{{'Popular'|translate}}</dt>
        }
    </div>
    <!-- map -->
    <div class="ratio-4-5 m-t-5"
         [toggleClass]="'!ng-hide'"
         [toggleClassBy]="toggleService.getState(['storeFinder', 'map'])">
        <ng-container *ngTemplateOutlet="mapTmpl"></ng-container>
    </div>
    <!-- list -->
    <div class="wrap"
         [toggleClass]="'!ng-hide'"
         [toggleClassBy]="toggleService.getState(['storeFinder', 'list'])">
        <ng-container *ngTemplateOutlet="resultsTmpl"></ng-container>
    </div>
    <!-- popular -->
    <div class="wrap p-t-5"
         [toggleClass]="'!ng-hide'"
         [toggleClassBy]="toggleService.getState(['storeFinder', 'popular'])">
        <ng-container *ngTemplateOutlet="popularSearchesTmpl"></ng-container>
    </div>
</div>
}@else {
<!-- DESKTOP -->
<div class="wrap flex p-r-0">
    <!-- main content -->
    <div class="c-4 m-r-0 m-b-0 flex-shrink-0 overflow-x-hidden height-100vh">
        <div class="height-100 _detailWrapper"
             [class._open]="isPreviewVisible">
            <div class="w-6 height-100 custom-scrollbar p-r-5 p-t-5">
                <ng-container *ngTemplateOutlet="formTmpl"></ng-container>

                <!-- suggested cities -->
                @if (!isResultsView && popularSearches?.length) {
                <div class="m-t-10">
                    <ng-container *ngTemplateOutlet="popularSearchesTmpl"></ng-container>
                </div>
                }

                <!-- results -->
                <ng-container *ngTemplateOutlet="resultsTmpl"></ng-container>
            </div>
            <div class="w-6 height-100 custom-scrollbar p-r-5 p-t-5">
                @if (currentStore) {
                <page-store-finder-details [store]="currentStore"></page-store-finder-details>
                }
            </div>
        </div>
    </div>
    <div class="flex-grow ">
        <div class="_mapWrapper">
            <div class="_map pos-relative">
                <ng-container *ngTemplateOutlet="mapTmpl"></ng-container>
            </div>
        </div>
    </div>
</div>
}


<!-- --------------------------- TEMPLATES ----------------------- -->

<!-- TEMPLATE / FORM -->
<ng-template #formTmpl>
    <form method="POST">
        <h1 class="h1 m-b-2-s m-b-2-m"
            *iCms="'title' of content"></h1>
        <!-- country selection -->
        <form-field class="block m-t-5"
                    [class.ng-hide]="isResultsView">
            <select name="country"
                    cy-addressAddCountry
                    [attr.placeholder]="'Country'| translate"
                    [(ngModel)]="country"
                    (ngModelChange)="onCountryChange()"
                    required>
                @for (country of countries | orderBy: ['name']; track country) {
                <option [value]="country.code">{{country.name| translate}}</option>
                }
            </select>
        </form-field>

        <form-mui-field class="block m-t-5 pos-relative"
                        [label]="('Postcode, Town or City'| translate)"
                        [hideSideIcon]="true">
            <input type="text"
                   name="address"
                   #addressInput
                   [attr.placeholder]="'Postcode, Town or City' | translate"
                   (keyup.enter)="search()"
                   [(ngModel)]="address" />
            <button class="top-50 right-4"
                    style="position:absolute"
                    [status]="status"
                    [iconButton]
                    [icon]="isResultsView ? 'close' : 'search'"
                    (click)="isResultsView ? reset() : search()"></button>
        </form-mui-field>
        <result [status]="status"></result>
    </form>
</ng-template>

<!-- TEMPLATE / MAP -->
<ng-template #mapTmpl>
    <div class="fill overflow-hidden">
        <shell></shell>
        <google-map class="fill"
                    [fitBounds]="true"
                    [stores]="mapModels"
                    [maxZoom]="isResultsView ? 13:8"
                    [markerLimit]="1000">
        </google-map>
    </div>
</ng-template>

<!-- TEMPLATE / RESULTS -->
<ng-template #popularSearchesTmpl>
    <p class="s2 m-b-1"
       *iCms="'popularSearchesTitle' of content; skipEmpty:true"></p>
    @for (item of popularSearches; track item) {
    <p (click)="searchFor(item.name)"
       class="cursor-pointer m-t-4 p2">{{item.name}}</p>
    }
</ng-template>

<!-- TEMPLATE / RESULTS -->
<ng-template #resultsTmpl>
    @if (isResultsView) {
    <div class="m-t-5">
        @for (store of findableModels; track store) {
        <div class="cursor-pointer flex flex-middle p-t-3 p-b-3 b-t b-col-4"
             (click)="previewStore(store)">
            <page-store-finder-store [store]="store"
                                     class="block flex-grow"></page-store-finder-store>
            <aside class=" m-l-5"><i class="icon-chevron-right"></i></aside>
        </div>
        }
    </div>
    }
</ng-template>